// Func = limiting Scope for this file
var lastScrollTop = 0;

if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){
	window.onscroll = function() {
		const header = document.getElementById('header');
		if (window.scrollY > 50) {
			header.classList.add('down');
		} else {
			header.classList.remove('down');
		}
	};
	
	window.addEventListener('resize', () => {
		// resizeWindow();
	});

	// FORM focus animation
	if(document.querySelectorAll('.form-module__field:not(.gdpr)').length > 0){
		document.querySelectorAll('.form-module__field:not(.gdpr)').forEach(field => {
			const input = field.querySelector('input, textarea, select');
			if (input) {
				input.addEventListener('focus', () => field.classList.add('moved'));
			}
		})
	}

	//Default Signup
	if(document.querySelectorAll('.field:not(.gdpr)').length > 0){
		document.querySelectorAll('.field:not(.gdpr)').forEach(field => {
			const input = field.querySelector('input, textarea, select');
			if (input) {
				input.addEventListener('focus', () => field.classList.add('moved'));
			}
		})
	}

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

	//HOTEL SELECTION
	const navSelect = document.getElementById('hotelSelect');
	const trigger = navSelect.querySelector('.hotel-select__button');

	trigger.addEventListener('click', (e) => {
		e.stopPropagation(); 
		navSelect.classList.toggle('open');
	});

	document.addEventListener('click', () => {
		navSelect.classList.remove('open');
	});
	
//Booking
document.addEventListener('DOMContentLoaded', function() {
    const overlay = document.getElementById('booking-overlay');
    const openBtn = document.querySelector('.header__right .btn');
    const closeBtn = document.getElementById('close-booking');
    const form = document.getElementById('stayntouch-form');

    // 1. Abrir y Cerrar
	if(openBtn){
		openBtn.addEventListener('click', (e) => {
			e.preventDefault();
			overlay.classList.add('active');
		});
	}

	if(closeBtn){
		closeBtn.addEventListener('click', () => {
			overlay.classList.remove('active');
		});
	}


    // 2. Inicializar Calendarios (Flatpickr)
    const config = {
        dateFormat: "m-d-Y",
        minDate: "today",
        onChange: function(selectedDates, dateStr, instance) {
            if (instance.element.id === 'checkin-picker') {
                checkout.set('minDate', dateStr);
            }
        }
    };

    const checkin = flatpickr("#checkin-picker", config);
    const checkout = flatpickr("#checkout-picker", config);

    // 3. Enviar a la URL externa
    form.addEventListener('submit', function(e) {
        e.preventDefault();
        
        const checkinVal = document.getElementById('checkin-picker').value;
        const checkoutVal = document.getElementById('checkout-picker').value;
        const adults = document.getElementById('adults-count').value;
        const kids = document.getElementById('kids-count').value;
		const hotel = form.querySelector('.custom-select').value;

        if(!checkinVal || !checkoutVal) {
            alert("Please select dates");
            return;
        }

		if(hotel !== "columbia") {

			const finalurl = "https://lanternrockhill.com/";
			window.open(finalurl, '_blank');

		}else{

			const baseUrl = "https://lanterncolumbia.ibe.stayntouch.com/search-results";
        	const finalUrl = `${baseUrl}?checkin=${checkinVal}&checkout=${checkoutVal}&adults=${adults}&kids=${kids}`;
			
			window.open(finalUrl, '_blank');

		};
    });
});
})();

function scrollW(){
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		if(!document.getElementById('header').classList.contains('down'))  {
			document.getElementById('header').classList.add('down');
			if(document.querySelector('.js-logo')){
				
				setTimeout(() => {
					document.querySelector('.js-logo').classList.add('changed');
					document.querySelector('.js-logo').setAttribute('src', document.querySelector('.js-logo').getAttribute('data-scroll'))
				}, 500);
			}
		}
	} else {
		if(document.getElementById('header').classList.contains('down')) {
			document.getElementById('header').classList.remove('down');
			if(document.querySelector('.js-logo')){
				setTimeout(() => {
					document.querySelector('.js-logo').classList.remove('changed');
					document.querySelector('.js-logo').setAttribute('src', document.querySelector('.js-logo').getAttribute('data-original'))
				}, 600);
			}
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}

//Border sign-up footer
	document.addEventListener('DOMContentLoaded', function() {
		const thankyouMsg = document.querySelector('.thankyouMsg'); 
		const deco = document.querySelector('.footer__top__signup');

		if (thankyouMsg && deco) {
			const observer = new MutationObserver(function(mutations) {
				mutations.forEach(function(mutation) {
					
					if (thankyouMsg.style.display === 'block') {
						deco.classList.add('all-borders');
					}
				});
			});

			
			observer.observe(thankyouMsg, { attributes: true, attributeFilter: ['style'] });
		}
	});
//End of Func